var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneFlagForChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 38.75C30.3553 38.75 38.75 30.3553 38.75 20C38.75 9.64466 30.3553 1.25 20 1.25C9.64466 1.25 1.25 9.64466 1.25 20C1.25 30.3553 9.64466 38.75 20 38.75Z",
    fill: "#E41E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.75L18.75 21.25L16.875 15.5L21.875 11.875H15.6875L13.75 6.25L11.875 11.875H5.625L10.625 15.5L8.75 21.25L13.75 17.75ZM22.0625 22.0625L20.625 22.375L22 22.9375V24.375L22.9375 23.3125L24.3125 23.8125L23.5 22.625L24.375 21.5L22.9375 21.8125L22.0625 20.625V22.0625ZM24.1875 17.8125L23.125 18.75L24.5625 18.625L25.1875 20L25.4375 18.5625L26.875 18.4375L25.625 17.6875L25.9375 16.25L24.875 17.1875L23.625 16.4375L24.1875 17.8125ZM24.5625 12.9375L25 14.375L25.4375 13H26.875L25.75 12.125L26.1875 10.6875L25 11.5625L23.875 10.625L24.3125 12.0625L23.125 12.875L24.5625 12.9375ZM22.0625 7.9375V9.375L22.9375 8.1875L24.375 8.5L23.5 7.375L24.3125 6.1875L22.9375 6.75L22 5.625V7.0625L20.625 7.625L22.0625 7.9375Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneFlagForChina);
export default __webpack_public_path__ + "static/media/emojione_flag-for-china.b152fe98b6a62f8ed44deccb9670a30b.svg";
export { ForwardRef as ReactComponent };